// extracted by mini-css-extract-plugin
module.exports = {"reservationNote":"ReservationNote_reservationNote__C_UDW","link":"ReservationNote_link__G9ANl"};